<template>
  <div
    class="container__drawer"
    @mouseover="hoverDrawer = true"
    @mouseleave="hoverDrawer = false"
  >
  <v-navigation-drawer
    v-if="!onlyAccessPulso"
    :value="$vuetify.breakpoint.lgAndUp || drawer"
    :temporary="$vuetify.breakpoint.mdAndDown"
    :mini-variant="$vuetify.breakpoint.lgAndUp && !locked"
    :expand-on-hover="$vuetify.breakpoint.lgAndUp && !locked"
    :width="
      $vuetify.breakpoint.mdAndUp ? 295 : undefined
      /* DEFAULT VALUE = 256 PROVIDED BY VUETIFY */
    "
    fixed
    clipped
    app
    @input="$emit('input', $event)"
  >
    <v-list :dense="$vuetify.breakpoint.mdAndDown">
      <!-- Home -->
      <v-list-item to="/home">
        <v-list-item-action id="homeMenuItem">
          <v-icon color="primary">mdi-home</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("menu.home") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- Create request group -->
      <v-list-group no-action>
        <template v-slot:activator>
          <v-list-item-action id="createRequestMenuItem">
            <v-icon color="primary">mdi-file-document-edit</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{
              $t("menu.createRequest")
            }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item link to="/request" v-if="hasRoles(NAMED_ROLES.VIEW_CI)">
          <v-list-item-title>
            {{ $t("menu.request") }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          to="/incident"
          v-if="hasRoles(NAMED_ROLES.VIEW_INCIDENT)"
        >
          <v-list-item-title>{{ $t("menu.incident") }}</v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          to="/problem"
          v-if="hasRoles(NAMED_ROLES.VIEW_PROBLEM) && !isCitizen()"
        >
          <v-icon color="primary"></v-icon>
          <v-list-item-title>{{ $t("menu.problem") }}</v-list-item-title>
        </v-list-item>
      </v-list-group>

      <!-- My request list group -->
     <!-- <v-list-group no-action>
        <template v-slot:activator>
          <v-list-item-action>
            <v-icon color="primary">mdi-view-headline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{
              $t("menu.myRequestsGroup")
            }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          v-if="hasRoles(NAMED_ROLES.VIEW_REQUEST)"
          link
          to="/requests"
        >
          <v-list-item-title>{{ $t("menu.requests") }}</v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          to="/incidents"
          v-if="hasRoles(NAMED_ROLES.VIEW_INCIDENT)"
        >
          <v-list-item-title>{{ $t("menu.incidents") }}</v-list-item-title>
        </v-list-item>

        <v-list-item
          link
          to="/problems"
          v-if="hasRoles(NAMED_ROLES.VIEW_PROBLEM) && !isCitizen()"
        >
          <v-list-item-title>{{ $t("menu.problems") }}</v-list-item-title>
        </v-list-item>
      </v-list-group> -->

      <v-list-item to="/requests">
        <v-list-item-action id="myRequestsMenuItem">
          <v-icon color="primary">mdi-view-headline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("menu.myRequestsGroup") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- Approvals -->
      <v-list-item
        to="/approvals"
        v-if="hasRoles(NAMED_ROLES.MODIFY_APRROVALS) && !isCitizen()"
        @mouseover="hover = true"
        @mouseleave="hover = false"
      >
        <v-list-item-action id="approvalsMenuItem">
          <span class="babge-buttonNavigation--approvals">
            <v-icon color="primary">mdi-playlist-check</v-icon>
            <v-badge
              v-if="total > 0"
              color="red"
              overlap
            >
              <span
                slot="badge"
                v-bind:style="{
                  color: 'white',
                }"
              ></span>
            </v-badge>
          </span>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("menu.approvals") }}</v-list-item-title>
        </v-list-item-content>
        <!--
        <v-list-item-action>
          <v-badge
            v-if="loaded"
            :color="colorCount()"
            overlap
          >
            <span
              slot="badge"
              v-bind:style="{
                color: 'white',
              }"
            >
            </span>
          </v-badge>
          <v-progress-circular
            v-else
            indeterminate
            size="20"
          ></v-progress-circular>
        </v-list-item-action>
        -->
      </v-list-item>

      <!-- KDB list -->
      <v-list-item to="/knowledge-items"
        v-if="!isCitizen()">
        <v-list-item-action id="kdbMenuItem">
          <v-icon color="primary">mdi-lightbulb</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("menu.kdbList") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!--- administrator cache -->
      <v-list-item to="/cache" v-if="hasRoles(NAMED_ROLES.VIEW_ADMIN) && !isCitizen()">
        <v-list-item-action>
          <v-icon color="primary">mdi-cached</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("menu.cache") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- Call to me -->
      <v-list-item v-if="!isCitizen()" to="/calltome">
        <v-list-item-action id="callToMeMenuItem">
          <v-icon color="primary">mdi-phone</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("menu.calltome") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- suggestions and comments -->
      <!-- THE LINK IN VUE WILL BE <v-list-item to="/suggest"> -->
      <v-list-item to="/suggestion" v-if="!isCitizen()">
        <v-list-item-action id="suggestionsMenuItem">
          <v-icon color="primary">mdi-mailbox</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("menu.suggestions") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- <v-list-item @click.stop="$emit('menuitem:logout')">
        <v-list-item-action>
          <v-icon color="highlighted">mdi-logout</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t('menu.logout') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->
    </v-list>

    <!-- QRs -->
    <v-list-item v-if="!isAppInstalled" class="container__qr">
      <v-list-item-action>
        <v-icon></v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>
          <div class="container__img">
            <img
              alt="QR Android"
              src="@/assets/QR_PlayStore.jpg"
              contain
              width="180"
              position="rigth fixed"
            />
            <img
              alt="Android"
              src="@/assets/logo_badge_googlePlay.png"
              contain
              width="150"
              position="rigth fixed"
              class ="imagebadge"
            />
          </div>

          <div class="container__img">
            <img
              alt="QR IOS"
              src="@/assets/QR_AppStore.png"
              contain
              width="180"
              position="rigth fixed"
            />
            <img
              alt="iOS"
              src="@/assets/logo_badge_appStore.png"
              contain
              width="150"
              position="left fixed"
              class ="imagebadge"
            />
          </div>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <template v-slot:append v-if="$vuetify.breakpoint.mdAndUp">
      <v-list>
        <v-list-item @click.stop="$emit('locked', !locked)">
          <v-list-item-action>
            <v-icon color="primary">{{
              locked ? "mdi-lock" : "mdi-lock-open"
            }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t(`menu.${locked ? "unlockMenu" : "lockMenu"}`) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
  </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { STATUS as NEWS_STATUS } from '@/store/modules/tickets';
import { NAMED_ROLES } from '@/store/modules/session';

export default {
  props: {
    drawer: {
      type: Boolean,
      default: false,
    },
    locked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loaded: false,
      hover: false,
      hoverDrawer: false,
      isAppInstalled: true,
      onlyAccessPulso: false,
    };
  },
  computed: {
    ...mapGetters({
      hasRoles: 'session/hasRole',
    }),
    ...mapState({
      user: ({ session: { session } }) => (session != null ? session.user : null),
      total: ({ tickets: { total } }) => total,
      success: ({ tickets: { status } }) => status === NEWS_STATUS.SUCCESS,
    }),
    NAMED_ROLES() {
      return NAMED_ROLES;
    },
  },
  methods: {
    async approvalsCount() {
      await this.$store.dispatch('tickets/listApprovals', {});
      this.loaded = true;
    },
    hasGroupTEST() {
      return this.user.KdGroupMember;
    },
    isCitizen() {
      return this.user.hasIosUser();
    },
    colorCount() {
      if (this.total > 0) {
        return 'red';
      } if (this.total === 0 && this.hover) {
        return 'grey';
      }
      return 'grey lighten-1';
    },
    async callToMe() {
      const user = this.$store.getters['session/user'];
      const { dni, mobilePhone } = user;
      const nombreApp = 'MICS';
      const idOrquestador = '40c4a960-b078-40e4-9545-b14e4dcce796';

      try {
        const response = await this.dashboardClient.callToMe({
          apiCges: {
            delegado: this.$store.getters['session/user'].userid,
            endpoint: `centralita/orquestadores/${ idOrquestador }/procesos/llamadas/contactame`,
          },
          telefono: mobilePhone,
          nombreApp,
          dni,
        });
        console.log(response);
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.approvalsCount();
    this.onlyAccessPulso = localStorage.getItem('onlyAccessPulso');
  },
  async created() {
    this.dashboardClient = this.$api.getClient('dashboard');
    const userTokenList = await this.$api.getClient('userInfo').getAppInstalled();
    this.isAppInstalled = userTokenList && userTokenList.length > 0;
    localStorage.setItem('isAppInstalled', this.isAppInstalled);
  },
};
</script>

<style lang="scss" scoped>
  .v-list-item__title {
    line-height: 1.3;
  }
  .container__qr .v-list-item__action{
    display: none!important;;
  }
  .container__img {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .babge-buttonNavigation--approvals {
    position: relative;
  }
  .babge-buttonNavigation--approvals > span {
    position: initial;
  }
  .babge-buttonNavigation--approvals .v-badge__wrapper span {
    color: white;
    width: 11px;
    height: 12px;
    min-width: inherit;
    min-height: inherit;
  }
</style>
